import React, { useMemo } from 'react'
import { readStoredLocale } from '../features/preferences/utils/localePreferenceStorage'
import { pickInitialLocale } from '../features/preferences/utils/pickInitialLocale'
import IntlProviderWithLocale from './IntlProviderWithLocale'

// Wraps public routes (login, login callback) with IntlProvider seeded from the
// last persisted locale (set by the authenticated PreferencesProvider on
// resolve/update). Falls back to the browser locale on first visit or when
// storage is unavailable.
const PublicLocalizedShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const locale = useMemo(() => pickInitialLocale(readStoredLocale()), [])
  return <IntlProviderWithLocale locale={locale}>{children}</IntlProviderWithLocale>
}

export default PublicLocalizedShell
